import { render, staticRenderFns } from "./MesaLicencias.vue?vue&type=template&id=50eb90b8&"
import script from "./MesaLicencias.vue?vue&type=script&lang=js&"
export * from "./MesaLicencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports